import styled from 'styled-components';
import { palette } from '../../../theme/colors';

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 40px 16px;
`;

export const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 40px;
  border: 1px solid ${palette.gold};
  background-color: ${palette.goldWithZeroPointFifteenOpacity};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 40px;
    height: 40px;
  }
`;

export const Title = styled.h2`
  color: ${palette.white};
  font-family: 'Roboto-Bold';
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin: 0;
`;

export const Body = styled.p`
  color: ${palette.ashGray};
  font-family: 'Roboto-Regular';
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  margin: 0;
`;

export const CalloutWrapper = styled.div`
  align-self: stretch;
`;

export const Spacer = styled.div`
  flex: 1;
`;
